import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/shield-close.vue
var o = {
	name: "DtIconShieldClose",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--shield-close"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Shield Close",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M5.824.532a.5.5 0 0 1 .352 0l4 1.5a.5.5 0 0 1 .324.468V6c0 1.723-1.14 3.1-2.17 4.001a11.338 11.338 0 0 1-2.053 1.418l-.038.02-.01.006-.004.001S6.223 11.448 6 11l-.224.447h-.001l-.004-.002-.01-.006-.038-.02a10.362 10.362 0 0 1-.613-.355c-.39-.244-.914-.603-1.44-1.063C2.64 9.101 1.5 7.723 1.5 6V2.5a.5.5 0 0 1 .324-.468l4-1.5ZM6 11l-.224.447c.14.07.308.07.448 0L6 11Zm0-.569a10.341 10.341 0 0 0 1.67-1.183C8.64 8.4 9.5 7.278 9.5 6V2.846L6 1.534 2.5 2.846V6c0 1.277.86 2.4 1.83 3.249A10.341 10.341 0 0 0 6 10.43ZM4.396 4.146a.5.5 0 0 1 .708 0L6 5.043l.896-.897a.5.5 0 1 1 .708.708l-.897.896.897.896a.5.5 0 1 1-.708.708L6 6.457l-.896.897a.5.5 0 1 1-.708-.708l.897-.896-.897-.896a.5.5 0 0 1 0-.708Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=shield-close.js.map